import { Chapter } from "@/components/Chapter";
import { Reveal } from "@/components/Reveal";
import { STUDIO_IMAGE } from "@/data/content";

const FramedImage = ({ src, alt, caption }) => (
    <Reveal className="relative">
        <div className="absolute -inset-0 translate-x-3 translate-y-3 border border-wood/15" />
        <div className="group relative overflow-hidden">
            <img
                src={src}
                alt={alt}
                loading="lazy"
                className="aspect-[4/3] w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
            />
        </div>
        <p className="mt-3 font-mono text-[10px] uppercase tracking-[0.25em] text-fog">{caption}</p>
    </Reveal>
);

export const Studio = () => (
    <>
        <Chapter id="studio" number="01" label="Who We Are" title="A Studio Where Design Meets Engineering" testid="manifesto-chapter-02">
            <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:gap-14">
                <Reveal delay={0.15} className="space-y-6 text-base font-light leading-relaxed text-mute sm:text-lg">
                    <p>
                        NoirNest is a multidisciplinary studio led by Architects and Engineers. For over
                        10 years, we have been shaping residential and commercial environments—not just
                        to look complete, but to feel complete.
                    </p>
                    <p>
                        Because a well-designed space is not defined by how it appears on day one, but
                        by how naturally it integrates into your life over time.
                    </p>
                </Reveal>
                <FramedImage src={STUDIO_IMAGE.src} alt={STUDIO_IMAGE.alt} caption={STUDIO_IMAGE.caption} />
            </div>
        </Chapter>
        <Chapter id="philosophy" number="02" label="Our Philosophy" title="Design as a Reflection of Identity" testid="manifesto-chapter-03" className="bg-sand">
            <Reveal delay={0.15} className="max-w-2xl space-y-6 text-base font-light leading-relaxed text-mute sm:text-lg">
                <p>
                    A home is not a composition of objects—it is a reflection of the person who lives
                    within it.
                </p>
                <p>
                    We design around your persona, your routines, your instincts—so that every corner
                    feels familiar, intentional, and effortless.
                </p>
            </Reveal>
            <Reveal delay={0.25}>
                <blockquote className="mt-12 max-w-3xl border-l-2 border-terra pl-8 font-serif text-2xl italic leading-snug text-wood sm:text-3xl">
                    “We don’t begin with layouts or catalogs. We begin with you.”
                </blockquote>
            </Reveal>
        </Chapter>
    </>
);
